import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    username: "",
    password: "",
    role: "empleado",
  });
  const [error, setError] = useState("");
  const [permisosEdit, setPermisosEdit] = useState(null);
  const [actividad, setActividad] = useState([]);
  const [modal, setModal] = useState(null);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  /* ================================
     CARGAR USUARIOS
  =================================*/
  const cargarUsuarios = async () => {
    try {
      const res = await axios.get("/auth/users", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsuarios(res.data.users || []);
    } catch (e) {
      console.log("❌ Error:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarUsuarios();
  }, []);

  /* ================================
     CREAR USUARIO
  =================================*/
  const crearUsuario = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post("/auth/register", form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.data.success) {
        setError(res.data.error || "Error creando usuario");
        return;
      }

      setForm({ username: "", password: "", role: "empleado" });
      cargarUsuarios();
    } catch {
      setError("Error en servidor");
    }
  };

  /* ================================
     ELIMINAR
  =================================*/
  const eliminarUsuario = async (id) => {
    if (!window.confirm("¿Eliminar usuario?")) return;

    await axios.delete(`/auth/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    cargarUsuarios();
  };

  /* ================================
     BLOQUEAR / DESBLOQUEAR
  =================================*/
  const bloquear = async (u) => {
    await axios.put(
      `/auth/block/${u.id}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    cargarUsuarios();
  };

  const desbloquear = async (u) => {
    await axios.put(
      `/auth/permissions/${u.id}`,
      { blocked: false },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    cargarUsuarios();
  };

  /* ================================
     INVALIDAR SESIÓN
  =================================*/
  const cerrarSesionUsuario = async (id) => {
    await axios.put(
      `/auth/invalidate/${id}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    alert("Sesión cerrada en el dispositivo del usuario.");
  };

  /* ================================
     EDITAR PERMISOS
  =================================*/
  const guardarPermisos = async () => {
    await axios.put(
      `/auth/permissions/${permisosEdit.id}`,
      { canView: permisosEdit.canView },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setModal(null);
    cargarUsuarios();
  };

  const togglePermiso = (clave) => {
    setPermisosEdit({
      ...permisosEdit,
      canView: {
        ...permisosEdit.canView,
        [clave]: !permisosEdit.canView[clave],
      },
    });
  };

  /* ================================
     CAMBIAR ROL
  =================================*/
  const cambiarRol = async (u, nuevoRol) => {
    await axios.put(
      `/auth/role/${u.id}`,
      { role: nuevoRol },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    cargarUsuarios();
  };

  /* ================================
     HISTORIAL
  =================================*/
  const verHistorial = async (u) => {
    const res = await axios.get(`/auth/activity/${u.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setActividad(res.data.list || []);
    setModal("historial");
  };

  /* ================================
     RENDER
  =================================*/
  if (loading) return <div style={{ padding: 20 }}>Cargando…</div>;

  return (
    <div className="page-dark" style={{ padding: 25 }}>
      {/* BOTÓN VOLVER */}
      <button
        onClick={() => navigate("/ajustes")}
        className="glass-btn"
        style={{
          marginBottom: 20,
          background: "#444",
          padding: "6px 15px",
        }}
      >
        ← Volver
      </button>

      <h1 style={{ color: "white", fontSize: 26 }}>Gestión de Usuarios</h1>

      {/* GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 20,
        }}
      >
        {/* FORMULARIO */}
        <div className="glass-box" style={{ padding: 20 }}>
          <h3 style={{ color: "white" }}>Crear usuario</h3>

          <form onSubmit={crearUsuario} style={{ display: "grid", gap: 10 }}>
            <input
              type="text"
              placeholder="Usuario"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              className="input-dark"
            />

            <input
              type="password"
              placeholder="Contraseña"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="input-dark"
            />

            <select
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
              className="input-dark"
            >
              <option value="admin">Administrador</option>
              <option value="empleado">Empleado</option>
              <option value="lectura">Solo lectura</option>
            </select>

            {error && <div style={{ color: "#ff7777" }}>{error}</div>}

            <button className="glass-btn">Crear usuario</button>
          </form>
        </div>

        {/* LISTA */}
        <div className="glass-box" style={{ padding: 20 }}>
          <h3 style={{ color: "white" }}>Usuarios</h3>

          <table className="table-dark" style={{ width: "100%", fontSize: 13 }}>
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Rol</th>
                <th>Estado</th>
                <th style={{ textAlign: "center" }}>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {usuarios.map((u) => (
                <tr key={u.id}>
                  <td>{u.username}</td>
                  <td>
                    <select
                      className="input-dark"
                      value={u.role}
                      onChange={(e) => cambiarRol(u, e.target.value)}
                      style={{ fontSize: 12 }}
                    >
                      <option value="admin">Admin</option>
                      <option value="empleado">Empleado</option>
                      <option value="lectura">Lectura</option>
                    </select>
                  </td>
                  <td>
                    {u.blocked ? (
                      <span style={{ color: "#ff6666" }}>Bloqueado</span>
                    ) : (
                      <span style={{ color: "#66ff99" }}>Activo</span>
                    )}
                  </td>

                  <td style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                    {/* PERMISOS */}
                    <button
                      className="glass-btn"
                      style={{ padding: "3px 8px" }}
                      onClick={() => {
                        setPermisosEdit(u);
                        setModal("permisos");
                      }}
                    >
                      Permisos
                    </button>

                    {/* HISTORIAL */}
                    <button
                      className="glass-btn"
                      onClick={() => verHistorial(u)}
                      style={{ padding: "3px 8px" }}
                    >
                      Logs
                    </button>

                    {/* DESCONEXIÓN */}
                    <button
                      className="glass-btn"
                      style={{ padding: "3px 8px" }}
                      onClick={() => cerrarSesionUsuario(u.id)}
                    >
                      Off
                    </button>

                    {/* BLOQUEAR */}
                    <button
                      className="glass-btn"
                      style={{ padding: "3px 8px", background: "#ff4444" }}
                      onClick={() => bloquear(u)}
                    >
                      🔒
                    </button>

                    {/* ELIMINAR */}
                    <button
                      className="glass-btn"
                      style={{ padding: "3px 8px", background: "#d9534f" }}
                      onClick={() => eliminarUsuario(u.id)}
                    >
                      X
                    </button>
                  </td>
                </tr>
              ))}

              {usuarios.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center", padding: 12 }}>
                    No hay usuarios creados
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================================
         MODAL PERMISOS
      =================================*/}
      {modal === "permisos" && permisosEdit && (
        <div className="glass-box" style={{ marginTop: 20, padding: 20 }}>
          <h3 style={{ color: "white" }}>
            Permisos de {permisosEdit.username}
          </h3>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: 10,
              marginTop: 10,
            }}
          >
            {[
              "clientes",
              "maquinas",
              "facturas",
              "presupuestos",
              "compras",
              "bancos",
              "correo",
              "documentos",
              "ajustes",
              "usuarios",
            ].map((permiso) => (
              <label
                key={permiso}
                style={{
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <input
                  type="checkbox"
                  checked={permisosEdit.canView?.[permiso] || false}
                  onChange={() => togglePermiso(permiso)}
                />
                {permiso}
              </label>
            ))}
          </div>

          <button
            className="glass-btn"
            style={{ marginTop: 10 }}
            onClick={guardarPermisos}
          >
            Guardar permisos
          </button>

          <button
            className="glass-btn"
            style={{ marginTop: 10, background: "#444" }}
            onClick={() => setModal(null)}
          >
            Cerrar
          </button>
        </div>
      )}

      {/* ================================
         MODAL HISTORIAL
      =================================*/}
      {modal === "historial" && (
        <div className="glass-box" style={{ marginTop: 20, padding: 20 }}>
          <h3 style={{ color: "white" }}>Historial</h3>

          <div
            style={{
              maxHeight: 300,
              overflowY: "auto",
              fontSize: 12,
              background: "rgba(0,0,0,0.25)",
              padding: 10,
              borderRadius: 6,
              color: "#ddd",
            }}
          >
            {actividad.map((a, i) => (
              <div key={i} style={{ marginBottom: 6 }}>
                <strong>{a.timestamp?.substring(0, 19).replace("T", " ")}</strong>
                <br />
                {a.action}
              </div>
            ))}

            {actividad.length === 0 && <div>No hay actividad registrada.</div>}
          </div>

          <button
            className="glass-btn"
            style={{ marginTop: 10, background: "#444" }}
            onClick={() => setModal(null)}
          >
            Cerrar
          </button>
        </div>
      )}
    </div>
  );
}
